
import 'primeicons/primeicons.css';
import { AutoComplete } from 'primereact/autocomplete';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import CustomerComponet from '../../customers/CustomerComponet';
import { useCustomer } from '../../customers/useCustomer';
import logo_svg from "../../public/images/logo.svg";
import imgCustomer from "../../public/images/user.avif";
import CustomerShowComponet from '../../customers/CustomerShowComponet';

function BookingCustomerStep({ onDataChange, bookingCustomerData }) {
    const toast = useRef(null);
    // eslint-disable-next-line no-unused-vars
    const [loading_handel, set_loading_handel] = useState(true);
    const [show_new_customer, set_show_new_customer] = useState(false)
    const {
        visitor_name, setvisitor_name, customer, set_customer,
        handelcustomer_by_name, search_customer_by_name, filtered_customers, itemTemplate_filtered_customers
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useCustomer();

    useEffect(() => {
        set_customer(bookingCustomerData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        onDataChange(customer)
        // if(customer?.ID_customer && customer?.state===0)
        // {
        //     msgs.current.show([
        //         { severity: 'error', detail: '', summary: "  العميــل فــي قائمــة الحظــر. ", sticky: true, closable: false }
        //     ]);
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer]);

    return (
        <div>
            <div class="ibox">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div class="ibox-body ">
                    <Dialog dir="rtl" header={<center className='color-ebony '> عمـــيل جــــديد  <i className='fa fa-user '></i> <i className='fa fa-plus '></i></center>} visible={show_new_customer} maximizable={true} style={{ width: window.innerWidth <= 1230 ? '100%' : '70vw', height: window.innerWidth <= 1230 ? '100%' : 'auto', fontFamily: "Cairo" }} onHide={() => set_show_new_customer(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                        <CustomerComponet set_customer={set_customer} set_show_new_customer={set_show_new_customer} toast={toast}></CustomerComponet>
                    </Dialog>
                    <div class="row">
                        <div class="col-md-12">
                            <div className="row font-15">
                                <div className="col-md-12 pb-4" style={{ border: "1px solid rgba(0,0,0,.1" }}>
                                    <label id="lvisitor_name_search" className="font-bold mt-4 " >
                                        أختــار العميــل
                                        <i className="fa fa-search pr-1" ></i>
                                    </label>
                                    <hr></hr>
                                    <div className='row'>
                                        <div className="col-md-6 col-12 mb-4 font-bold" >

                                            <AutoComplete value={visitor_name} suggestions={filtered_customers} completeMethod={(e) => search_customer_by_name(e)} itemTemplate={itemTemplate_filtered_customers}
                                                maxLength={255} placeholder="الاسم" className="col-md-12 col-12 pr-0" style={{ fontFamily: "Cairo" }} inputStyle={{ fontFamily: "Cairo", width: "100%", paddingRight: "2rem" }} panelStyle={{ fontFamily: "Cairo", textAlign: "right" }}
                                                virtualScrollerOptions={{ itemSize: 38 }} field="visitor_name" onChange={(e) => handelcustomer_by_name(e)} scrollHeight="400px" />

                                        </div>
                                        <div className="col-md-6 col-12  font-bold" >
                                            <Button icon="ti ti-plus " outlined className='col-md-4 col-12 ' label={<><i className="fa fa-user pr-1" ></i> عميــل جــــديد  </>} onClick={(e) => {
                                                setvisitor_name("");
                                                document.getElementById("lvisitor_name_search").style.color = "black"
                                                set_show_new_customer(!show_new_customer)
                                            }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 ">
                                    <CustomerShowComponet toast={toast} customer={customer}  ></CustomerShowComponet>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookingCustomerStep